import React, { useState, useEffect, useRef } from 'react';
import {
  Container,
  Typography,
  Grid,
  TextField,
  IconButton,
  InputLabel,
  Select,
  Button,
  FormControl,
  MenuItem,
  Radio,
  Paper,
  Box,
  InputAdornment,
} from '@mui/material';
import {
  LocalizationProvider,
  DatePicker,
  TimePicker,
} from '@mui/x-date-pickers';
import ModalClientes from '../GestionDeClientes/ModalClientes.js';
import ModalUsuarios from './ModalUsuarios.js';
import AssignmentIcon from '@mui/icons-material/Assignment';
import PersonIcon from '@mui/icons-material/Person';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import SaveIcon from '@mui/icons-material/Save';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import NotesIcon from '@mui/icons-material/Notes';
import CategoryIcon from '@mui/icons-material/Category';
import DescriptionIcon from '@mui/icons-material/Description';
import BusinessIcon from '@mui/icons-material/Business';
import DateFnsUtils from '@date-io/date-fns';
import { produce } from 'immer';
import { generate } from 'shortid';
import esLocale from 'date-fns/locale/es';
import {
  obtenerTareasNotificacion,
  obtenerTiposTareas,
  registrarTarea,
} from '../../actions/TareasAction.js';
import { useStateValue } from '../../contexto/store.js';
import SearchIcon from '@mui/icons-material/Search';
import {
  obtenerClientes,
  obtenerDireccionesCliente,
  obtenerPosiblesClientes,
  obtenerTelefonosCliente,obtenerClientesPaginado,
} from '../../actions/ClientesAction.js';
import { obtenerListaUsuarios } from '../../actions/UsuariosAction.js';
import TFacturasTareas from '../GestionDeCobranzas/TFacturasTarea.js';
import {
  cambiarDeEstadoPosibleCobro,
  obtenerPosiblesCobrosNotificacion,
} from '../../actions/CobranzasAction.js';
import { RegistrarAccion } from '../../actions/AuditoriaAction.js';
import moment from 'moment';
import { useHistory } from "react-router-dom";
export default function NuevaTarea(props) {
  const history = useHistory();
  const mounted = useRef(true);
  const [datosCargados,setDatosCargados]=useState(false);
  const [clientesCargados, setClientesCargados] = useState(false);
  const [{ sesionUsuario }, dispatch] = useStateValue();
  const [tarea, setTarea] = useState({
    TAREA_ID: '',
    CODTAREA: 0,
    USUARIOASIGNADO: '',
    CLIENTE_ID: '',
    FECHACREACION: '',
    FECHAVTO: '',
    TIPOTAREA: '',
    NUMTAREA: '',
    CLIENTE: '',
    PRESUPUESTO_ID: '',
  });
  const [usuario, setUsuario] = useState('');
  const [userNameUsuarioAsignado, setUserNameUsuarioAsignado] = useState('');
  const [fechaSeleccionadaFc, setFechaSeleccionadaFc] = useState(new Date());
  const [fechaSeleccionadaFv, setFechaSeleccionadaFv] = useState(new Date());
  const [horaSeleccionadaHi, setHoraSeleccionadaHi] = useState(new Date());
  const [modalBuscar, setModalBuscar] = useState(false);
  const [modalBuscarUsuario, setModalBuscarUsuario] = useState(false);
  const [DataUsu, setDataUsu] = useState([]);
  const [tipotarea, setTipoTarea] = useState('');
  const [Datatt, setDatatt] = useState([]);
  const [Datacl, setDatacl] = useState([]);
  const [paginaClientes, setPaginaClientes] = useState(1);
const [tamanoPaginaClientes] = useState(20);
const [totalRegistrosClientes, setTotalRegistrosClientes] = useState(0);
const [buscarCliente, setBuscarCliente] = useState('');
const solicitudClientesRef = useRef(0);
  const [telefonosTareas, setTelefonosTareas] = useState([]);
  const [DataTelCli, setDataTelCli] = useState([]);
  const [direccionesTareas, setDireccionesTareas] = useState([]);
  const [descris, setDescris] = useState([]);
  const [Datadire, setDatadire] = useState([]);
  const [presupuesto, setPresupuesto] = useState(false);
  const [facturas, setFacturas] = useState([]);
  const [mostrarFacturas, setMostrarFacturas] = useState(false);
  const [cobradorId, setCobradorId] = useState('');
  const [tareaSinDatos, setTareaSinDatos] = useState(false);
  const [radioValor, setRadioValor] = useState('clientes');
  const ingresarValoresMemoria = (e) => {
    const { name, value } = e.target;
    setTarea((anterior) => ({
      ...anterior,
      [name]: value,
    }));
  };
const abrirModal = () => {
  setPaginaClientes(1);
  setBuscarCliente('');
  setDatacl([]);
  setTotalRegistrosClientes(0);
  setModalBuscar(true);
};
  const selectTipoTareahandleChange = (event) => {
    setTipoTarea(event.target.value);
  };

const cerrarModal = () => {
  setModalBuscar(false);
  setBuscarCliente('');
  setPaginaClientes(1);
};

  const abrirModalUsuario = () => {
    setModalBuscarUsuario(true);
  };

  const cerrarModalUsuario = () => {
    setModalBuscarUsuario(false);
  };

  const seleccionarUsuario = (usuarioSeleccionado) => {
    setUsuario(usuarioSeleccionado.nombrecompleto);
    setUserNameUsuarioAsignado(usuarioSeleccionado.userName);
    setCobradorId(usuarioSeleccionado.id);
    cerrarModalUsuario();
  };

  const crearTarea = (e) => {
    e.preventDefault();
    if (usuario === '') {
      dispatch({
        type: 'OPEN_SNACKBAR',
        openMensaje: {
          open: true,
          mensaje: 'Debe Seleccionar el Usuario A quien va a asignar la tarea ',
        },
      });
    } else {
      let fechac =
        fechaSeleccionadaFc.getFullYear() +
        '-' +
        (fechaSeleccionadaFc.getMonth() + 1).toString().padStart(2, '0') +
        '-' +
        fechaSeleccionadaFc.getDate().toString().padStart(2, '0') +
        'T' +
        fechaSeleccionadaFc.getHours().toString().padStart(2, '0') +
        ':' +
        fechaSeleccionadaFc.getMinutes().toString().padStart(2, '0') +
        ':00';
      let fechav =
        fechaSeleccionadaFv.getFullYear() +
        '-' +
        (fechaSeleccionadaFv.getMonth() + 1).toString().padStart(2, '0') +
        '-' +
        fechaSeleccionadaFv.getDate().toString().padStart(2, '0') +
        'T' +
        horaSeleccionadaHi.getHours().toString().padStart(2, '0') +
        ':' +
        horaSeleccionadaHi.getMinutes().toString().padStart(2, '0') +
        ':00';
      let objetoTarea = {};
      if (
        telefonosTareas[0] === undefined &&
        direccionesTareas[0] === undefined
      ) {
        objetoTarea = {
          CODTAREA: parseInt(tarea.CODTAREA),
          ASIGNADOPOR: sesionUsuario.usuario.nombrecompleto,
          USUARIOASIGNADO: usuario,
          FECHACREACION: fechac,
          FECHAVTO: fechav,
          CLIENTE_ID: tarea.CLIENTE_ID,
          TIPOTAREA_ID: tipotarea,
          NUMTAREA: tarea.NUMTAREA,
          UserName: userNameUsuarioAsignado,
        };
      } else if (
        telefonosTareas[0] !== undefined &&
        direccionesTareas[0] === undefined
      ) {
        if (
          telefonosTareas[0].DESCRITELEFONO !== '' ||
          telefonosTareas[0].DETALLESTELEFONO !== ''
        ) {
          objetoTarea = {
            CODTAREA: parseInt(tarea.CODTAREA),
            ASIGNADOPOR: sesionUsuario.usuario.nombrecompleto,
            USUARIOASIGNADO: usuario,
            FECHACREACION: fechac,
            FECHAVTO: fechav,
            CLIENTE_ID: tarea.CLIENTE_ID,
            TIPOTAREA_ID: tipotarea,
            NUMTAREA: tarea.NUMTAREA,
            TELEFONOSTAREAS: telefonosTareas,
            UserName: userNameUsuarioAsignado,
          };
        } else {
          objetoTarea = {
            CODTAREA: parseInt(tarea.CODTAREA),
            ASIGNADOPOR: sesionUsuario.usuario.nombrecompleto,
            USUARIOASIGNADO: usuario,
            FECHACREACION: fechac,
            FECHAVTO: fechav,
            CLIENTE_ID: tarea.CLIENTE_ID,
            TIPOTAREA_ID: tipotarea,
            NUMTAREA: tarea.NUMTAREA,
            UserName: userNameUsuarioAsignado,
          };
        }
      } else if (
        telefonosTareas[0] === undefined &&
        direccionesTareas[0] !== undefined
      ) {
        if (
          direccionesTareas[0].DESCRIDIRECCION !== '' ||
          direccionesTareas[0].DETALLESDIRECCION !== ''
        ) {
          objetoTarea = {
            CODTAREA: parseInt(tarea.CODTAREA),
            ASIGNADOPOR: sesionUsuario.usuario.nombrecompleto,
            USUARIOASIGNADO: usuario,
            FECHACREACION: fechac,
            FECHAVTO: fechav,
            CLIENTE_ID: tarea.CLIENTE_ID,
            TIPOTAREA_ID: tipotarea,
            NUMTAREA: tarea.NUMTAREA,
            DIRECCIONESTAREAS: direccionesTareas,
            UserName: userNameUsuarioAsignado,
          };
        } else {
          objetoTarea = {
            CODTAREA: parseInt(tarea.CODTAREA),
            ASIGNADOPOR: sesionUsuario.usuario.nombrecompleto,
            USUARIOASIGNADO: usuario,
            FECHACREACION: fechac,
            FECHAVTO: fechav,
            CLIENTE_ID: tarea.CLIENTE_ID,
            TIPOTAREA_ID: tipotarea,
            NUMTAREA: tarea.NUMTAREA,
            UserName: userNameUsuarioAsignado,
          };
        }
      } else {
        objetoTarea = {
          CODTAREA: parseInt(tarea.CODTAREA),
          ASIGNADOPOR: sesionUsuario.usuario.nombrecompleto,
          USUARIOASIGNADO: usuario,
          FECHACREACION: fechac,
          FECHAVTO: fechav,
          CLIENTE_ID: tarea.CLIENTE_ID,
          TIPOTAREA_ID: tipotarea,
          NUMTAREA: tarea.NUMTAREA,
          TELEFONOSTAREAS: telefonosTareas,
          DIRECCIONESTAREAS: direccionesTareas,
          UserName: userNameUsuarioAsignado,
        };
      }
      if (presupuesto) {
        objetoTarea['PRESUPUESTO_Id'] = tarea.PRESUPUESTO_ID;
      } else if (mostrarFacturas) {
        objetoTarea['FACTURAS'] = facturas;
      } else if (radioValor === 'posiblesclientes') {
        objetoTarea['POSIBLECLIENTEId'] = tarea.CLIENTE_ID;
        delete tarea['CLIENTE_ID'];
      }
      if (props.location.state !== undefined && props.location.state.cobranza) {
        objetoTarea['POSIBLECOBRO'] =
          props.location.state.facturas[0].posiblecobro;
      }
      //FORMA ALTERNATIVA DE CARGAR DATOS DENTRO DE UN OBJETO, PUEDE SER UTILIZADA PARA NO REPETIR LAS CARGAS DE DATOS EN UN OBJETO
      objetoTarea['AsignadorId'] = sesionUsuario.usuario.id;
      registrarTarea(objetoTarea).then((response) => {
        if (response.status === 200) {
          dispatch({
            type: 'OPEN_SNACKBAR',
            openMensaje: {
              open: true,
              mensaje: 'Se creo exitosamente la Tarea',
            },
          });
       history.goBack();
          let objetoNoti;
          //eslint-disable-next-line
          {
            props.location === 'asignarTarea' ||
            (props.location.state !== undefined &&
              props.location.state.Modal === true)
              ? (objetoNoti = {
                  USUARIOASIGNADO: objetoTarea.USUARIOASIGNADO,
                  UserName: userNameUsuarioAsignado,
                })
              : (objetoNoti = {
                  USUARIOASIGNADO: objetoTarea.USUARIOASIGNADO,
                  UserName: sesionUsuario.usuario.userName,
                });
          }
          obtenerTareasNotificacion(objetoNoti);
          obtenerPosiblesCobrosNotificacion();
          setTarea({
            TAREA_ID: '',
            CODTAREA: 0,
            USUARIOASIGNADO: '',
            CLIENTE_ID: '',
            FECHACREACION: '',
            FECHAVTO: '',
            TIPOTAREA: '',
            NUMTAREA: '',
            CLIENTE: '',
            PRESUPUESTO_ID: '',
          });
          setTelefonosTareas([]);
          setDireccionesTareas([]);
          setUserNameUsuarioAsignado('');
          setUsuario(sesionUsuario.usuario.nombrecompleto);
          if (
            props.location.state !== undefined &&
            props.location.state.cobranza
          ) {
            history.goBack();
          }
          let objetoAudi = {
            usuario: sesionUsuario.usuario.nombrecompleto,
            accion: 'Registro',
            panel: 'Gestion de Tareas',
            tabla: 'TAREAS',
            filaafectada: 'NUEVO REGISTRO',
            UsuarioId: sesionUsuario.usuario.id,
          };
          RegistrarAccion(objetoAudi);
        } else if (response.status === 400) {
          dispatch({
            type: 'OPEN_SNACKBAR',
            openMensaje: {
              open: true,
              mensaje:
                'Todos los campos son obligatorios asegurese de llenarlos ',
            },
          });
        } else {
          dispatch({
            type: 'OPEN_SNACKBAR',
            openMensaje: {
              open: true,
              mensaje: 'Errores al intentar guardar ',
            },
          });
        }
      });
      if (props.location.state !== undefined && props.location.state.cobranza) {
        let objetoCobro = {
          notificado: 'ASIGNADO',
          cobrador: usuario,
          cobrador_id: cobradorId,
        };
        props.location.state.facturas.map((posiblecobro) => {
          cambiarDeEstadoPosibleCobro(
            posiblecobro.transaccionId,
            objetoCobro
          ).then((response) => {
            if (response.status !== 200) {
              console.log('ERROR EN CAMBIAR DE ESTADO POSIBLECOBRO');
            }
          });
          return null;
        });
      }
    }
  };

  const volver = () => {
    setTarea({
      TAREA_ID: '',
      CODTAREA: 0,
      USUARIOASIGNADO: '',
      CLIENTE_ID: '',
      FECHACREACION: '',
      FECHAVTO: '',
      TIPOTAREA: '',
      NUMTAREA: '',
      CLIENTE: '',
      PRESUPUESTO_ID: '',
    });
    setHoraSeleccionadaHi(new Date());
    setTelefonosTareas([]);
    setDireccionesTareas([]);
    if (props.history !== undefined) {
      history.goBack();

    }
  };
  const seleccionarCliente = (cliente) => {
    //const id = cliente.clientE_Id;
    const id = cliente.clientE_Id ? cliente.clientE_Id : cliente.posibleclientE_Id;
    // setTarea({
    //   TAREA_ID: tarea.TAREA_ID,
    //   CODTAREA: tarea.CODTAREA,
    //   NUMTAREA: tarea.NUMTAREA,
    //   CLIENTE_ID: cliente.clientE_Id
    //     ? cliente.clientE_Id
    //     : cliente.posibleclientE_Id,
    //   USUARIOASIGNADO: tarea.USUARIOASIGNADO,
    //   FECHACREACION: tarea.FECHACREACION,
    //   FECHAVTO: tarea.FECHAVTO,
    //   TIPOTAREA: tarea.TIPOTAREA,
    //   CLIENTE: cliente.nombre + ' ' + cliente.apellido,
    //   PRESUPUESTO_ID: tarea.PRESUPUESTO_ID,
    // });
     setTarea((anterior) => ({
    ...anterior,
    CLIENTE_ID: id,
    CLIENTE: `${cliente.nombre || ''} ${
      cliente.apellido || ''
    }`.trim(),
  }));
    // obtenerTelefonosCliente(id).then((response) => {
    //   const Data = response.data;
    //   setDataTelCli(Data);
    // });
    // obtenerDireccionesCliente(id).then((response) => {
    //   const Data = response.data;
    //   setDatadire(Data);
    // });
    // setModalBuscar(false);
      cerrarModal();
  };
useEffect(() => {
  const cargarTelefonosYDirecciones = async () => {
    if (!tarea.CLIENTE_ID) {
      setDataTelCli([]);
      setDatadire([]);
      return;
    }

    console.log('Cargando contactos del cliente:', tarea.CLIENTE_ID);

    const responseTelefonos = await obtenerTelefonosCliente(tarea.CLIENTE_ID);
    console.log('Teléfonos cliente:', responseTelefonos?.data);
    setDataTelCli(responseTelefonos?.data || []);

    const responseDirecciones = await obtenerDireccionesCliente(tarea.CLIENTE_ID);
    console.log('Direcciones cliente:', responseDirecciones?.data);
    setDatadire(responseDirecciones?.data || []);
  };

  cargarTelefonosYDirecciones();
}, [tarea.CLIENTE_ID]);

const radioValorHandleChange = (event) => {
  setRadioValor(event.target.value);
  setPaginaClientes(1);
  setBuscarCliente('');
  setDatacl([]);
  setTotalRegistrosClientes(0);
};

const buscarClienteHandleChange = (valor) => {
  setBuscarCliente(valor || '');
  setPaginaClientes(1);
};

const cambiarPaginaClientes = (nuevaPagina) => {
  setPaginaClientes(nuevaPagina);
};
useEffect(() => {
  // No consulta clientes si el modal está cerrado.
  if (!modalBuscar) {
    return;
  }

  const solicitudActual =
    ++solicitudClientesRef.current;

  let activo = true;

  const cargarClientesModal = async () => {
    setClientesCargados(false);

    try {
      if (radioValor === 'clientes') {
        const response =
          await obtenerClientesPaginado(
            paginaClientes,
            tamanoPaginaClientes,
            buscarCliente
          );

        if (
          !activo ||
          solicitudActual !==
            solicitudClientesRef.current
        ) {
          return;
        }

        if (
          !response ||
          response.status !== 200
        ) {
          throw new Error(
            'No se pudieron obtener los clientes.'
          );
        }

        const resultado = response.data || {};

        const filas =
          resultado.data ??
          resultado.Data ??
          [];

        const total =
          resultado.totalRegistros ??
          resultado.TotalRegistros ??
          0;

        setDatacl(
          Array.isArray(filas) ? filas : []
        );

        setTotalRegistrosClientes(total);
      } else if (
        radioValor === 'posiblesclientes'
      ) {
        const response =
          await obtenerPosiblesClientes(
            sesionUsuario.usuario.id
          );

        if (
          !activo ||
          solicitudActual !==
            solicitudClientesRef.current
        ) {
          return;
        }

        if (
          !response ||
          response.status !== 200
        ) {
          throw new Error(
            'No se pudieron obtener los posibles clientes.'
          );
        }

        const filas = Array.isArray(
          response.data
        )
          ? response.data
          : [];

        setDatacl(filas);
        setTotalRegistrosClientes(
          filas.length
        );
      }
    } catch (error) {
      if (
        !activo ||
        solicitudActual !==
          solicitudClientesRef.current
      ) {
        return;
      }

      console.error(
        'Error cargando clientes del modal:',
        error
      );

      setDatacl([]);
      setTotalRegistrosClientes(0);
    } finally {
      if (
        activo &&
        solicitudActual ===
          solicitudClientesRef.current
      ) {
        setClientesCargados(true);
      }
    }
  };

  cargarClientesModal();

  return () => {
    activo = false;
  };
}, [
  modalBuscar,
  radioValor,
  paginaClientes,
  tamanoPaginaClientes,
  buscarCliente,
  sesionUsuario.usuario.id,
]);
  /*
  
  YOYOYOYO 06072026
  
  */
 useEffect(() => {
  const cargarCombosIniciales = async () => {
    try {
      const responseTipos = await obtenerTiposTareas();
      console.log('TIPOS TAREAS:', responseTipos?.data);
      setDatatt(responseTipos?.data || []);

      const responseUsuarios = await obtenerListaUsuarios();
      console.log('USUARIOS:', responseUsuarios?.data);
      setDataUsu(responseUsuarios?.data || []);
      setDatosCargados(true);
    } catch (error) {
      console.error('Error cargando combos de NuevaTarea:', error);
      setDatatt([]);
      setDataUsu([]);
      setDatosCargados(true);
    }
  };

  cargarCombosIniciales();
}, []);
  useEffect(() => {
    /*RRR: Verifica si se esta llamando al componente desde otro o si se le esta enviando datos desde el history
      para luego habilitar el textfiel de seleccionar usuario para adignar tarea*/
    if (props.location !== 'asignarTarea') {
      setUsuario(sesionUsuario.usuario.nombrecompleto);
      setUserNameUsuarioAsignado(sesionUsuario.usuario.userName);
    }

    /*RRR: verifica si la tarea es solicitada desde otro componente (Presupuestos,Facturas)
         debido a que estos componentes envian los datos del cliente en el location, si no existe 
         un estado en el location quiere decir que es una tarea normal y se debe especificar el cliente entonces
         carga el array de clientes para mostrar en el modal*/
    if (mounted.current) {
      if (props.location.state === undefined) {
        setTareaSinDatos(true);
        /*RRR:PRESUPUESTOS/TAREA-02 verifica si la solicitud de nueva tarea viene desde presupuestos
             para mostrar los datos del presupuesto y del cliente en la tarea a aser creada*/
      } else if (props.location.state.presupuestO_Id) {
        setTarea({
          TAREA_ID: tarea.TAREA_ID,
          CODTAREA: tarea.CODTAREA,
          NUMTAREA: tarea.NUMTAREA,
          CLIENTE_ID: props.location.state.cliente.clientE_Id,
          USUARIOASIGNADO: props.location.state.usuarioasignado,
          FECHACREACION: tarea.FECHACREACION,
          FECHAVTO: tarea.FECHAVTO,
          TIPOTAREA: tarea.TIPOTAREA,
          CLIENTE:
            props.location.state.cliente.nombre +
            ' ' +
            props.location.state.cliente.apellido,
          PRESUPUESTO_ID: props.location.state.presupuestO_Id,
        });
        /*RRR:PRESUPUESTOS/TAREA-03 cambia el estado de la variable presupuesto a true 
            para comunicar al componente que se trata de una tarea a un presupuesto*/
        setPresupuesto(true);
        /*RRR:FACTURAS/TAREA-02 verifica si la solicitud enviada viene desde facturas */
      // } else if (
      //   props.location.state.facturas &&
      //   !props.location.state.cobranza
      // ) {
//       } else if (
//   props.location.state.facturas &&
//   !props.location.state.cobranza
// ) {
//   const facturasSeleccionadas = props.location.state.facturas;

//   setMostrarFacturas(true);
//   setFacturas(facturasSeleccionadas);

//   const primeraFactura = facturasSeleccionadas[0];

//   setTarea((anterior) => ({
//     ...anterior,
//     CLIENTE_ID:
//       primeraFactura.cliente?.clientE_Id ||
//       primeraFactura.clienteId ||
//       '',
//     USUARIOASIGNADO:
//       primeraFactura.usuario?.nombrecompleto ||
//       '',
//     CLIENTE:
//       typeof primeraFactura.cliente === 'string'
//         ? primeraFactura.cliente
//         : `${primeraFactura.cliente?.nombre ?? ''} ${primeraFactura.cliente?.apellido ?? ''}`.trim(),
//   }));
} else if (
  props.location.state.facturas &&
  !props.location.state.cobranza
) {
  const state = props.location.state;

  const facturasSeleccionadas = Array.isArray(state)
    ? state
    : state.facturas;

  if (!facturasSeleccionadas || facturasSeleccionadas.length === 0) {
    console.log('No llegaron facturas seleccionadas');
    return;
  }

  const primeraFactura = facturasSeleccionadas[0];

  setMostrarFacturas(true);
  setFacturas(facturasSeleccionadas);

  const cliente = primeraFactura.cliente;

  const clienteId =
    cliente?.clientE_Id ||
    primeraFactura.clienteId ||
    primeraFactura.CLIENTE_ID ||
    '';

  const nombreCliente =
    typeof cliente === 'string'
      ? cliente
      : `${cliente?.nombre ?? ''} ${cliente?.apellido ?? ''}`.trim();

  setTarea((anterior) => ({
    ...anterior,
    CLIENTE_ID: clienteId,
    USUARIOASIGNADO:
      primeraFactura.usuario?.nombrecompleto ||
      primeraFactura.usuarioasignado ||
      '',
    FECHACREACION: anterior.FECHACREACION,
    FECHAVTO: anterior.FECHAVTO,
    TIPOTAREA: anterior.TIPOTAREA,
    CLIENTE: nombreCliente,
    PRESUPUESTO_ID: anterior.PRESUPUESTO_ID,
  }));
        
        // /*RRR: FACTURAS/TAREA-03 elimina el item booleano del estado ya que no lo vamos a necesitar y cambia los
        //     estados del componente para poder mostrar lo necesario correspondiente a las facturas*/
        // delete props.location.state['facturas'];
        // setMostrarFacturas(true);
        // setFacturas(props.location.state);
        // setTarea({
        //   TAREA_ID: tarea.TAREA_ID,
        //   CODTAREA: tarea.CODTAREA,
        //   NUMTAREA: tarea.NUMTAREA,
        //   /*RRR: se especifica de esta manera por que dentro del estado vienen varios objetos
        //         pero nosotros solo necesitamos los datos del cliente que se repiten en todos entonces 
        //         tomamos solo los datos del primer objeto */
        //   CLIENTE_ID: props.location.state[0].cliente.clientE_Id,
        //   USUARIOASIGNADO: props.location.state[0].usuario.nombrecompleto,
        //   FECHACREACION: tarea.FECHACREACION,
        //   FECHAVTO: tarea.FECHAVTO,
        //   TIPOTAREA: tarea.TIPOTAREA,
        //   CLIENTE:
        //     props.location.state[0].cliente.nombre +
        //     ' ' +
        //     props.location.state[0].cliente.apellido,
        //   PRESUPUESTO_ID: tarea.PRESUPUESTO_ID,
        // });
          //  Nueva condición: si viene desde panelFacturasGeneral
  // if (props.location.state.origen === 'panelFacturasGeneral') {
  //   setMostrarFacturas(true);
  //   setFacturas(props.location.state.facturas);
  //   setTarea({
  //     ...tarea,
  //     CLIENTE_ID: props.location.state.facturas[0].cliente.clientE_Id,
  //     USUARIOASIGNADO: '', //  vacío para que el usuario se seleccione manualmente
  //     FECHACREACION: tarea.FECHACREACION,
  //     FECHAVTO: tarea.FECHAVTO,
  //     TIPOTAREA: tarea.TIPOTAREA,
  //     CLIENTE:
  //       // props.location.state.facturas[0].cliente.nombre +
  //       // ' ' +
  //       // props.location.state.facturas[0].cliente.apellido,
  //       typeof props.location.state.facturas[0].cliente === 'string'
  //     ? props.location.state.facturas[0].cliente
  //     : `${props.location.state.facturas[0].cliente?.nombre ?? ''} ${props.location.state.facturas[0].cliente?.apellido ?? ''}`.trim(),
  //     PRESUPUESTO_ID: tarea.PRESUPUESTO_ID,
  //   });
  // } else {
  //   //  Comportamiento original
  //   delete props.location.state['facturas'];
  //   setMostrarFacturas(true);
  //   setFacturas(props.location.state);
  //   setTarea({
  //     TAREA_ID: tarea.TAREA_ID,
  //     CODTAREA: tarea.CODTAREA,
  //     NUMTAREA: tarea.NUMTAREA,
  //     CLIENTE_ID: props.location.state[0].cliente.clientE_Id,
  //     USUARIOASIGNADO: props.location.state[0].usuario?.nombrecompleto || '',
  //     FECHACREACION: tarea.FECHACREACION,
  //     FECHAVTO: tarea.FECHAVTO,
  //     TIPOTAREA: tarea.TIPOTAREA,
  //     CLIENTE:
  //       props.location.state[0].cliente.nombre +
  //       ' ' +
  //       props.location.state[0].cliente.apellido,
  //     PRESUPUESTO_ID: tarea.PRESUPUESTO_ID,
  //   });
  // }
        /*RRR: FACTURAS/TAREA-04 verifica si la solicitud viene desde una tarea cerrada con facturas
              y no una tarea desde cero con las facturas que vienen desde la tabla de facturas */
      } else if (props.location.state.NTfacturas) {
        setMostrarFacturas(true);
        setFacturas(props.location.state.facturasNT);
        setTarea({
          TAREA_ID: tarea.TAREA_ID,
          CODTAREA: tarea.CODTAREA,
          NUMTAREA: tarea.NUMTAREA,
          CLIENTE_ID: props.location.state.CLIENTE_ID,
          USUARIOASIGNADO: props.location.state.USUARIOASIGNADO,
          FECHACREACION: tarea.FECHACREACION,
          FECHAVTO: tarea.FECHAVTO,
          TIPOTAREA: tarea.TIPOTAREA,
          CLIENTE: props.location.state.CLIENTE,
          PRESUPUESTO_ID: tarea.PRESUPUESTO_ID,
        });
        /* RRR: TAREAS/COBROS-02 se verifica si 3
        la solicitud se trata de una cobranza para poder mostrar los datos en pantalla */
      } else if (props.location.state && props.location.state.cobranza) {
        setMostrarFacturas(true);
        setFacturas(props.location.state.facturas);
        setTarea({
          TAREA_ID: tarea.TAREA_ID,
          CODTAREA: tarea.CODTAREA,
          NUMTAREA: tarea.NUMTAREA,
          CLIENTE_ID: props.location.state.facturas[0].clienteId,
          USUARIOASIGNADO: tarea.USUARIOASIGNADO,
          FECHACREACION: tarea.FECHACREACION,
          FECHAVTO: tarea.FECHAVTO,
          TIPOTAREA: tarea.TIPOTAREA,
          CLIENTE: props.location.state.facturas[0].clientefpc,
          PRESUPUESTO_ID: tarea.PRESUPUESTO_ID,
        });
      } else {
        /*RRR:si no, significa que la solicitud viene desde una tarea cerrada sin facturas y
            se quiere crear otra y recoge los datos*/
        setTarea({
          TAREA_ID: tarea.TAREA_ID,
          CODTAREA: tarea.CODTAREA,
          NUMTAREA: tarea.NUMTAREA,
          CLIENTE_ID: props.location.state.CLIENTE_ID,
          USUARIOASIGNADO: props.location.state.USUARIOASIGNADO,
          FECHACREACION: tarea.FECHACREACION,
          FECHAVTO: tarea.FECHAVTO,
          TIPOTAREA: tarea.TIPOTAREA,
          CLIENTE: props.location.state.CLIENTE,
          PRESUPUESTO_ID: tarea.PRESUPUESTO_ID,
        });
      }
      // obtenerTiposTareas().then((response) => {
      //   const Data = response.data;
      //   setDatatt(Data);
      // });
      // obtenerListaUsuarios().then((response) => {
      //   const Data = response.data;
      //   setDataUsu(Data);
      // });
    }
    return function cleanup() {
      mounted.current = false;
    };
  }, [sesionUsuario, tarea, props]);
  return (
    <Container component="main" maxWidth="lg" sx={{ py: 4 }}>
      <Paper
        elevation={0}
        sx={{
          background: 'linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)',
          borderRadius: 2,
          p: 3,
          mb: 4,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: 2,
              background: 'rgba(255,255,255,0.2)',
              backdropFilter: 'blur(10px)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <AssignmentIcon sx={{ fontSize: 32, color: 'white' }} />
          </Box>
          <Box>
            {mostrarFacturas && !props.location.state.cobranza ? (
              <Typography variant="h4" sx={{ color: 'white', fontWeight: 600 }}>
                NUEVA TAREA A FACTURAS
              </Typography>
            ) : presupuesto ? (
              <Typography variant="h4" sx={{ color: 'white', fontWeight: 600 }}>
                NUEVA TAREA A PRESUPUESTO
              </Typography>
            ) : props.location.state !== undefined && props.location.state.cobranza ? (
              <Typography variant="h4" sx={{ color: 'white', fontWeight: 600 }}>
                Asignar Posible Cobro
              </Typography>
            ) : (
              <Typography variant="h4" sx={{ color: 'white', fontWeight: 600 }}>
                NUEVA TAREA
              </Typography>
            )}
            <Typography
              variant="body2"
              sx={{ color: 'rgba(255,255,255,0.9)', mt: 0.5 }}
            >
              Complete los datos para crear una nueva tarea
            </Typography>
          </Box>
        </Box>
      </Paper>

      <Paper
        elevation={0}
        sx={{
          p: 4,
          mb: 3,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
        }}
      >
        <form onSubmit={(e) => { e.preventDefault(); crearTarea(e); }}>
          <Grid container spacing={4}>
            <Grid item xs={12} md={6} sx={{ display: 'none' }}>
              <TextField
                name="CODTAREA"
                value={tarea.CODTAREA}
                fullWidth
                onChange={ingresarValoresMemoria}
                variant="outlined"
                label="Codigo"
              />
            </Grid>
            {/*RRR: ASIGNAR/TAREAS/FEACTURAS-02 verificamos si la solicitud es desde el modal de facturas lo cual sugiere que es un asignacion */}

            {/* {props.location === 'asignarTarea' ||
            (props.location.state !== undefined &&
              props.location.state.Modal === true) ||
            (props.location.state !== undefined &&
              props.location.state.cobranza  ) ? ( */}
              {props.location === 'asignarTarea' ||
 (props.location.state !== undefined &&
  (props.location.state.Modal === true ||
   props.location.state.cobranza ||
   props.location.state.origen === 'panelFacturasGeneral')) ? (

              <Grid item xs={12} md={6}>
                <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
                  <IconButton
                    onClick={abrirModalUsuario}
                    sx={{
                      backgroundColor: 'primary.main',
                      color: 'white',
                      borderRadius: 2,
                      '&:hover': {
                        backgroundColor: 'primary.dark',
                      },
                    }}
                    aria-label="buscar"
                  >
                    <SearchIcon />
                  </IconButton>
                  <TextField
                    disabled={true}
                    name="usuario"
                    value={usuario}
                    fullWidth
                    variant="outlined"
                    label="Buscar Usuarios"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <PersonIcon sx={{ fontSize: 20, color: 'action.active', mr: 1.5 }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>
              </Grid>
            ) : (
              <Grid item xs={12} md={6}>
                <TextField
                  name="usuario"
                  value={usuario}
                  fullWidth
                  variant="outlined"
                  label="Usuario"
                  InputProps={{
                    readOnly: true,
                    startAdornment: (
                      <InputAdornment position="start">
                        <PersonIcon sx={{ fontSize: 20, color: 'action.active', mr: 1.5 }} />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            )}
            {props.location.state !== undefined &&
            props.location.state.cobranza ? (
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  disabled={true}
                  name="posblecobro"
                  value={
                    moment(
                      props.location.state.facturas[0].posiblecobro
                    ).format('DD/MM/YYYY') +
                    ' a las ' +
                    props.location.state.facturas[0].posiblecobro.substr(
                      11,
                      5
                    ) +
                    ' hs'
                  }
                  variant="outlined"
                  label="Fecha y Hora Pactadas con el cliente para el posible cobro"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AccessTimeIcon sx={{ fontSize: 20, color: 'action.active', mr: 1.5 }} />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            ) : null}
            <Grid item xs={12} md={6}>
              <LocalizationProvider locale={esLocale} utils={DateFnsUtils}>
                <DatePicker
                  disabled={true}
                  value={fechaSeleccionadaFc}
                  onChange={setFechaSeleccionadaFc}
                  label="Fecha de Creacion"
                  format="dd/MM/yyyy"
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      variant: 'outlined',
                      InputProps: {
                        startAdornment: (
                          <InputAdornment position="start">
                            <CalendarTodayIcon sx={{ fontSize: 20, color: 'action.active', mr: 1.5 }} />
                          </InputAdornment>
                        ),
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} md={6}>
              <LocalizationProvider locale={esLocale} utils={DateFnsUtils}>
                <DatePicker
                  value={fechaSeleccionadaFv}
                  onChange={setFechaSeleccionadaFv}
                  label="Fecha de Vencimiento"
                  format="dd/MM/yyyy"
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      variant: 'outlined',
                      InputProps: {
                        startAdornment: (
                          <InputAdornment position="start">
                            <CalendarTodayIcon sx={{ fontSize: 20, color: 'action.active', mr: 1.5 }} />
                          </InputAdornment>
                        ),
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} md={6}>
              <LocalizationProvider locale={esLocale} utils={DateFnsUtils}>
                <TimePicker
                  ampm={false}
                  label="Hora de Alerta"
                  value={horaSeleccionadaHi}
                  onChange={setHoraSeleccionadaHi}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      variant: 'outlined',
                      InputProps: {
                        startAdornment: (
                          <InputAdornment position="start">
                            <AccessTimeIcon sx={{ fontSize: 20, color: 'action.active', mr: 1.5 }} />
                          </InputAdornment>
                        ),
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>
            {/*RRR:PRESUPUESTOS/TAREA-04 verifica si la tarea corresponde a un presupuesto y muestra el textfield con 
              el numero de presupuesto y asi con los demas elementos que se necesitan como por ejemplo el historial*/}
            {presupuesto ? (
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  disabled={true}
                  name="PRESUPUESTO_ID"
                  value={props.location.state.codpresupuesto}
                  variant="outlined"
                  label="Presupuesto Nro."
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <DescriptionIcon sx={{ fontSize: 20, color: 'action.active', mr: 1.5 }} />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            ) : null}
            {tareaSinDatos ? (
              <Grid item xs={12}>
                <Box sx={{ p: 2, border: '1px solid', borderColor: 'divider', borderRadius: 2 }}>
                  <Typography sx={{ mb: 1, fontWeight: 600 }}>Tarea Para:</Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Radio
                        checked={radioValor === 'clientes'}
                        onChange={radioValorHandleChange}
                        value="clientes"
                        color="primary"
                      />
                      <Typography>Cliente</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Radio
                        checked={radioValor === 'posiblesclientes'}
                        onChange={radioValorHandleChange}
                        value="posiblesclientes"
                        color="primary"
                      />
                      <Typography>Posible Cliente</Typography>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            ) : null}
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
                <IconButton
                  onClick={abrirModal}
                  sx={{
                    backgroundColor: 'primary.main',
                    color: 'white',
                    borderRadius: 2,
                    '&:hover': {
                      backgroundColor: 'primary.dark',
                    },
                  }}
                  aria-label="buscar"
                >
                  <SearchIcon />
                </IconButton>
                <TextField
                  disabled={true}
                  name="CLIENTE"
                  value={tarea.CLIENTE}
                  fullWidth
                  variant="outlined"
                  label="CLIENTE"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <BusinessIcon sx={{ fontSize: 20, color: 'action.active', mr: 1.5 }} />
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
            </Grid>
            {mostrarFacturas === true ? (
              <Grid item xs={12}>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>Facturas:</Typography>
                <TFacturasTareas DataFact={facturas} />
              </Grid>
            ) : null}
            <Grid item xs={12} md={6}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel>Tipo Tarea</InputLabel>
                <Select
                  value={tipotarea}
                  onChange={selectTipoTareahandleChange}
                  label="Tipo Tarea"
                  startAdornment={
                    <InputAdornment position="start">
                      <CategoryIcon sx={{ fontSize: 20, color: 'action.active', ml: 1.5, mr: 1 }} />
                    </InputAdornment>
                  }
                >
                  <MenuItem value="">
                    <em>Ninguno</em>
                  </MenuItem>
                  {Datatt.map((tipotarea) => (
                    <MenuItem
                      key={tipotarea.tipotareA_Id}
                      value={tipotarea.tipotareA_Id}
                    >
                      {tipotarea.descritipotarea}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Box sx={{ mt: 4 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
              <Typography variant="h6" sx={{ fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
                <PhoneIcon sx={{ fontSize: 24 }} />
                Teléfonos
              </Typography>
              <Button
                variant="contained"
                color="primary"
                startIcon={<AddIcon />}
                onClick={() => {
                  setTelefonosTareas((telefonoActual) => [
                    ...telefonoActual,
                    {
                      CODTELEFONOTAREA: generate(),
                      DESCRITELEFONOTAREA: '',
                      DETALLESTELEFONOTAREA: '',
                    },
                  ]);
                }}
                sx={{
                  borderRadius: 2,
                  textTransform: 'none',
                  fontWeight: 600,
                  px: 3,
                  py: 1,
                }}
              >
                Agregar Teléfono
              </Button>
            </Box>
          </Box>
          {telefonosTareas.map((t, index) => {
            return (
              <Box key={t.CODTELEFONOTAREA} sx={{ mb: 2 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={5}>
                    <FormControl variant="outlined" fullWidth>
                      <InputLabel>Teléfono</InputLabel>
                      <Select
                        onChange={(e) => {
                          const DESCRITELEFONOTAREA = e.target.value;
                          setTelefonosTareas((telefonoActual) =>
                            produce(telefonoActual, (v) => {
                              v[index].DESCRITELEFONOTAREA = DESCRITELEFONOTAREA;
                            })
                          );
                        }}
                        value={t.DESCRITELEFONOTAREA}
                        label="Teléfono"
                        startAdornment={
                          <InputAdornment position="start">
                            <PhoneIcon sx={{ fontSize: 20, color: 'action.active', ml: 1.5, mr: 1 }} />
                          </InputAdornment>
                        }
                      >
                        <MenuItem value="">
                          <em>Ninguno</em>
                        </MenuItem>
                        {DataTelCli.map((telefono) => (
                          <MenuItem
                            key={telefono.telefonO_Id}
                            value={telefono.descritelefono}
                          >
                            {telefono.descritelefono +
                              ' (' +
                              telefono.detallestelefono +
                              ')'}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={5}>
                    <TextField
                      name="DETALLESTELEFONOTAREA"
                      value={t.DETALLESTELEFONOTAREA}
                      fullWidth
                      onChange={(e) => {
                        const DETALLESTELEFONOTAREA = e.target.value;
                        setTelefonosTareas((telefonoActual) =>
                          produce(telefonoActual, (v) => {
                            v[index].DETALLESTELEFONOTAREA = DETALLESTELEFONOTAREA;
                          })
                        );
                      }}
                      variant="outlined"
                      label="Detalles"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <NotesIcon sx={{ fontSize: 20, color: 'action.active', mr: 1.5 }} />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <Button
                      variant="contained"
                      color="error"
                      fullWidth
                      startIcon={<RemoveIcon />}
                      onClick={() => {
                        setTelefonosTareas((telefonoActual) =>
                          telefonoActual.filter(
                            (x) => x.CODTELEFONOTAREA !== t.CODTELEFONOTAREA
                          )
                        );
                      }}
                      sx={{
                        borderRadius: 2,
                        textTransform: 'none',
                        fontWeight: 600,
                        height: '56px',
                      }}
                    >
                      Eliminar
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            );
          })}
          <Box sx={{ mt: 4 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
              <Typography variant="h6" sx={{ fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
                <LocationOnIcon sx={{ fontSize: 24 }} />
                Direcciones
              </Typography>
              <Button
                variant="contained"
                color="primary"
                startIcon={<AddIcon />}
                onClick={() => {
                  setDireccionesTareas((direccionActual) => [
                    ...direccionActual,
                    {
                      CODDIRECCION: generate(),
                      DETALLESDIRECCION: '',
                      DESCRIDIRECCION: '',
                      CIUDAD: {
                        CIUDAD_Id: '',
                      },
                      BARRIO: {
                        BARRIO_Id: '',
                      },
                    },
                  ]);
                  setDescris((descriActual) => [
                    ...descriActual,
                    {
                      BARRIOS: '',
                      CIUDADES: '',
                    },
                  ]);
                }}
                sx={{
                  borderRadius: 2,
                  textTransform: 'none',
                  fontWeight: 600,
                  px: 3,
                  py: 1,
                }}
              >
                Agregar Dirección
              </Button>
            </Box>
          </Box>
          {
            (descris,
            direccionesTareas.map((d, index) => {
              return (
                <Box key={d.CODDIRECCION} sx={{ mb: 3 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={12}>
                      <FormControl variant="outlined" fullWidth>
                        <InputLabel>Direcci\u00f3n</InputLabel>
                        <Select
                          onChange={(e) => {
                            const DESCRIDIRECCION = e.target.value;
                            setDireccionesTareas((direccionActual) =>
                              produce(direccionActual, (v) => {
                                v[index].DESCRIDIRECCION =
                                  DESCRIDIRECCION.descridireccion;
                                v[index].CIUDAD.CIUDAD_Id =
                                  DESCRIDIRECCION.ciudad.ciudaD_Id;
                                v[index].BARRIO.BARRIO_Id =
                                  DESCRIDIRECCION.barrio.barriO_Id;
                              })
                            );

                            setDescris((descriActual) =>
                              produce(descriActual, (v) => {
                                v[index].CIUDADES =
                                  DESCRIDIRECCION.ciudad.descriciudad;
                                v[index].BARRIOS =
                                  DESCRIDIRECCION.barrio.describarrio;
                              })
                            );
                          }}
                          value={d.DESCRIDIRECCION.descridireccion}
                          label="Direcci\u00f3n"
                          startAdornment={
                            <InputAdornment position="start">
                              <LocationOnIcon sx={{ fontSize: 20, color: 'action.active', ml: 1.5, mr: 1 }} />
                            </InputAdornment>
                          }
                        >
                          {Datadire.map((direccion) => (
                            <MenuItem
                              key={direccion.direccioN_Id}
                              value={direccion}
                            >
                              {direccion.descridireccion}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        label="Barrio"
                        variant="outlined"
                        fullWidth
                        value={descris[index].BARRIOS}
                        InputProps={{
                          readOnly: true,
                          startAdornment: (
                            <InputAdornment position="start">
                              <LocationOnIcon sx={{ fontSize: 20, color: 'action.active', mr: 1.5 }} />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        label="Ciudad"
                        variant="outlined"
                        fullWidth
                        value={descris[index].CIUDADES}
                        InputProps={{
                          readOnly: true,
                          startAdornment: (
                            <InputAdornment position="start">
                              <BusinessIcon sx={{ fontSize: 20, color: 'action.active', mr: 1.5 }} />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={10}>
                      <TextField
                        name="DETALLESDIRECCION"
                        value={d.DETALLESDIRECCION}
                        fullWidth
                        onChange={(e) => {
                          const DETALLESDIRECCION = e.target.value;
                          setDireccionesTareas((direccionActual) =>
                            produce(direccionActual, (v) => {
                              v[index].DETALLESDIRECCION = DETALLESDIRECCION;
                            })
                          );
                        }}
                        variant="outlined"
                        label="Detalles"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <NotesIcon sx={{ fontSize: 20, color: 'action.active', mr: 1.5 }} />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <Button
                        variant="contained"
                        color="error"
                        fullWidth
                        startIcon={<RemoveIcon />}
                        onClick={() => {
                          setDireccionesTareas((direccionActual) =>
                            direccionActual.filter(
                              (x) => x.CODDIRECCION !== d.CODDIRECCION
                            )
                          );
                          setDescris((direccionActual) =>
                            direccionActual.filter(
                              (x) => x.CIUDADES !== descris.CIUDADES,
                              (y) => y.BARRIOS !== descris.BARRIOS
                            )
                          );
                        }}
                        sx={{
                          borderRadius: 2,
                          textTransform: 'none',
                          fontWeight: 600,
                          height: '56px',
                        }}
                      >
                        Eliminar
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              );
            }))
          }
          <Box sx={{ mt: 4 }}>
            <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600 }}>
              Detalles de la Tarea
            </Typography>
            <TextField
              name="NUMTAREA"
              value={tarea.NUMTAREA}
              onChange={ingresarValoresMemoria}
              variant="outlined"
              fullWidth
              multiline
              rows={4}
              placeholder="Detalles"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start" sx={{ alignSelf: 'flex-start', mt: 2 }}>
                    <NotesIcon sx={{ fontSize: 20, color: 'action.active', mr: 1.5 }} />
                  </InputAdornment>
                ),
              }}
            />
          </Box>
          <Box sx={{ display: 'flex', gap: 2, mt: 4, justifyContent: 'center' }}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
              sx={{
                flex: 1,
                maxWidth: 300,
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 600,
                py: 1.5,
                px: 4,
              }}
            >
              Crear Tarea
            </Button>
            <Button
              onClick={volver}
              variant="outlined"
              color="primary"
              startIcon={<ArrowBackIcon />}
              sx={{
                flex: 1,
                maxWidth: 300,
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 600,
                py: 1.5,
                px: 4,
              }}
            >
              Cancelar
            </Button>
          </Box>
          <Box sx={{ mt: 3 }}>
<ModalClientes
  data={Datacl}
  open={modalBuscar}
  handleClose={cerrarModal}
  seleccionarCliente={seleccionarCliente}
  datosCargados={clientesCargados}

  totalRegistros={
    radioValor === 'clientes'
      ? totalRegistrosClientes
      : 0
  }

  pagina={paginaClientes}
  tamanoPagina={tamanoPaginaClientes}

  buscarCliente={
    radioValor === 'clientes'
      ? buscarCliente
      : ''
  }

  onBuscarCliente={
    radioValor === 'clientes'
      ? buscarClienteHandleChange
      : undefined
  }

  onCambiarPagina={
    radioValor === 'clientes'
      ? cambiarPaginaClientes
      : undefined
  }
/>
            <ModalUsuarios
              data={DataUsu}
              open={modalBuscarUsuario}
              handleClose={cerrarModalUsuario}
              seleccionarUsuario={seleccionarUsuario}
              datosCargados={datosCargados}
            />
          </Box>
        </form>
      </Paper>
    </Container>
  );
}
